// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"TextCell_tooltipContainer__1IYTc","text":"TextCell_text__1MzZf","truncatedText":"TextCell_truncatedText__-rEbH","tooltipText":"TextCell_tooltipText__1wZgQ"};